module.exports = __webpack_public_path__ + "static/simplified-desktop-639c6d8af7588f98bb189a498a9dad07.webp";